import { useCallback, useEffect } from "react";

let usingKeyboard = false;
let consumers = 0;

const rememberKeyboard = () => {
  usingKeyboard = true;
};

const rememberPointer = () => {
  usingKeyboard = false;
};

const track = () => {
  if (consumers++ === 0) {
    document.addEventListener("keydown", rememberKeyboard, true);
    document.addEventListener("pointerdown", rememberPointer, true);
  }
  return () => {
    if (--consumers === 0) {
      document.removeEventListener("keydown", rememberKeyboard, true);
      document.removeEventListener("pointerdown", rememberPointer, true);
    }
  };
};

/**
 * Returns a getter for whether the user is currently driving the page from the keyboard — the same
 * heuristic the browser uses for `:focus-visible`, which cannot be used directly here because
 * editable elements always match it, however the focus arrived.
 *
 * A getter rather than state on purpose: the answer is only interesting at the moment something
 * receives focus, and every keystroke would otherwise re-render the consumer.
 */
export const useKeyboardModality = () => {
  useEffect(track, []);
  return useCallback(() => usingKeyboard, []);
};
